@for (train of trains; track indexTrackBy($index, train)) {
  <div>
    <trenitalia-train-details [train]="train" [original]="travelSolution"></trenitalia-train-details>
  </div>
}